import { UIError } from '$provider/models/error/UIError';

export class AppException extends Error {
  public readonly sendToSentry: boolean;
  public readonly data: any;
  public organizationName = '';
  public ignoreErrorWhitelist: string[] = [];
  /** When whitelist error messsage matches the actual error it will send it to sentry as Warn instead of Error */
  public warnErrorWhiteList: string[] = [];

  constructor(err: Error, data: unknown, sendToSentry = true) {
    super(err?.message);
    this.stack = err?.stack || this.stack;
    this.data = data;
    this.sendToSentry = !(err instanceof UIError) && sendToSentry;
  }

  public get passToSentry(): boolean {
    return this.sendToSentry && !this.shouldIgnoreSentry;
  }

  public get sendSentryAsWarn(): boolean {
    return this.sendToSentry && this.shouldSendSentryAsWarn;
  }

  get extras(): any {
    return {};
  }

  public getSentryOptions(): any {
    return {
      extra: this.getData()
    };
  }

  public getData(): any {
    return {
      data: JSON.stringify(this.data),
      organizationName: this.organizationName || '',
      extras: JSON.stringify(this.extras)
    };
  }

  public setIgnoreErrorWhitelist(whitelist: string[]): void {
    this.ignoreErrorWhitelist = whitelist || [];
  }

  public setWarnErrorWhiteList(whitelist: string[]): void {
    this.warnErrorWhiteList = whitelist || [];
  }

  private get shouldIgnoreSentry(): boolean {
    return this.ignoreErrorWhitelist?.some((error: string) =>
      this.message?.toLowerCase()?.includes(error?.toLowerCase())
    );
  }

  private get shouldSendSentryAsWarn(): boolean {
    return this.warnErrorWhiteList?.some((error: string) =>
      this.message?.toLowerCase()?.includes(error?.toLowerCase())
    );
  }
}
